import { useContext, useEffect } from "react"
import { Field, useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

export default function EnterpriseIds({ field, block, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    if (!form?.editMode) {
      formik.setFieldValue(
        field.field_name,
        userCtx.session.user.enterprise_id
      )
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Field name={field.field_name}>
      {({ field: formikField }) => (
        <>
          <input
            type="hidden"
            id={field.field_name}
            name={formikField.name}
            value={formikField.value}
          />
        </>
      )}
    </Field>
  )
}
